export default __webpack_public_path__ + "static/media/estetoscope.97f90989.svg";